import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0712 4.92882c-1.3986-1.39854-3.1804-2.35097-5.1203-2.73684-1.9398-.38586-3.9504-.18785-5.77768.56903-1.82728.75687-3.38908 2.03859-4.48789 3.68309C2.5865 8.0886 2 10.022 2 11.9998c0 1.9778.5865 3.9113 1.68533 5.5557 1.09881 1.6445 2.66061 2.9262 4.48789 3.6832 1.82728.7568 3.83788.9548 5.77768.5689 1.9399-.3858 3.7217-1.3382 5.1203-2.7368C20.9464 17.1954 22 14.652 22 11.9998c0-2.65211-1.0536-5.19562-2.9288-7.07098zm-6.071 14.07108l-3.0001-3 4-6.00008-5.99996 3.99998-3-3L17.0001 6.99982 13.0002 18.9999z",
    fill: "currentColor"
  }));
});